import { Training } from '@/app/entities/Training'
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { format } from 'date-fns'

const columnHelper = createColumnHelper<Training>()

const columns = [
  columnHelper.accessor('name', {
    id: 'name',
    header: () => (
      <div className="hidden pl-8 text-left md:block">Treinamento</div>
    ),
    cell: ({ row }) => (
      <div className="hidden pl-8 text-left md:block">{row.original?.name}</div>
    ),
  }),
  columnHelper.accessor('lessonsLength', {
    id: 'numberOfClasses',
    header: () => <div className="hidden text-right md:block">Aulas</div>,
    cell: ({ row }) => (
      <div className="hidden text-right md:block">
        {row.original?.lessonsLength} Aulas
      </div>
    ),
  }),
  columnHelper.accessor('createdAt', {
    id: 'data',
    header: () => <div className="hidden pr-8 text-right xl:block">Data</div>,
    cell: ({ row }) => (
      <div className="hidden  pr-8 text-right xl:block">
        {format(row.original.createdAt, 'dd/MM/yyyy')}
      </div>
    ),
  }),
]

interface UseTrainingTableProps {
  data: Training[]
}

export default function useTrainingTable({ data }: UseTrainingTableProps) {
  const table = useReactTable({
    data: data || [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return table
}
